import { useRouter } from 'next/router'
import { isEmpty, isNil } from 'ramda'

import type { Article, Category } from '@twisto/api-cms'

import {
  ContentNavigationChildren,
  ContentNavigationParent,
} from 'homepage/components/molecules'

import { CategoryContentNavigationArticles } from './category-content-navigation-articles'
import { isCurrentSubtree } from './helpers'

type Props = {
  categories: Category[]
}

export const CategoryContentNavigationCategories = ({ categories }: Props) => {
  const { asPath } = useRouter()

  // skip this component if current subtree doesn't own subcategories
  if (isNil(categories) || isEmpty(categories)) {
    return null
  }

  return (
    <ContentNavigationParent>
      {categories.map((category, index) => {
        if (isNil(category)) {
          return null
        }

        const { name, path, categories, articles } = category

        return (
          <ContentNavigationChildren
            key={index}
            href={path ?? ''}
            isCurrent={isCurrentSubtree(path, asPath)}
            label={name}
          >
            {isCurrentSubtree(path, asPath) && (
              <>
                <CategoryContentNavigationCategories
                  categories={categories as Category[]}
                />
                <CategoryContentNavigationArticles
                  articles={articles as Article[]}
                />
              </>
            )}
          </ContentNavigationChildren>
        )
      })}
    </ContentNavigationParent>
  )
}
